<template>
    <v-card>
        <v-toolbar flat>
            <v-toolbar-title>
                {{ imperative.imperative_type.desc }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="red" small flat rounded outlined icon><v-icon>delete</v-icon></v-btn>
        </v-toolbar>
    </v-card>
</template>

<script>
    export default {
        name: "DirectoryImperativeCard",
        props: {
            imperative: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                readOnly: true
            }
        }
    }
</script>

<style scoped>

</style>
